import { Label, resolveCycleStatus } from '@viapeople/components'
import { formatStepName } from '../../utils/helpers'
import type { CycleInfo } from './types'

export const getCyclesDetails = (cyclesData: CycleInfo[] | undefined) => {
	return (
		cyclesData?.map((cycle) => ({
			cycleName: cycle?.cycleInfo?.name || 'No active cycle',
			participantsCount: cycle?.cycleInfo?.participantsCount || 0,
			cycleSteps: cycle?.cycleInfo?.stepsCount || 0,
			status: cycle?.cycleInfo?.status || 'N/A',
			cycleId: cycle?.id || null,
			currentStep: cycle?.cycleInfo?.currentStep ? formatStepName(cycle.cycleInfo.currentStep) : 'N/A',
			nextStep: cycle?.cycleInfo?.nextStep ? formatStepName(cycle.cycleInfo.nextStep) : 'N/A',
		})) || []
	)
}

export const getCycleValues = (cycleDetails: ReturnType<typeof getCyclesDetails>) => {
	return cycleDetails?.map((cycleDetails) => [
		cycleDetails.cycleName,
		cycleDetails.participantsCount,
		cycleDetails.cycleSteps,
		<Label
			key='status'
			className='w-25! whitespace-nowrap'
			color={cycleDetails.status === 'in-progress' ? 'yellow' : 'green'}>
			{resolveCycleStatus(cycleDetails.status)}
		</Label>,
		cycleDetails.currentStep,
		cycleDetails.nextStep,
		cycleDetails.cycleId,
	])
}
